import React, { useState, useEffect } from 'react';  
import "./Kpidetails.css"; 
import { METRIC_INFO } from "./utils/metricInfo.js";
import { InfoTooltip } from "./utils/InfoTooltip.js";

  export function KPIDashboard() {  
      const [startDate, setStartDate] = useState('');  
      const [endDate, setEndDate] = useState('');  
      const [KPIData, setKPIData] = useState({});  
      const [isLoading, setIsLoading] = useState(false);  
      const [submittedRange, setSubmittedRange] = useState(null);  
      const [uniqueUserNames, setUniqueUserNames] = useState([]);  
      const [selectedUser, setSelectedUser] = useState('');  
   
      useEffect(() => {  
          const handleScroll = () => {  
              const footer = document.querySelector('footer');  
              if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {  
                  footer.style.display = 'block';  
              } else {  
                  footer.style.display = 'none';  
              }  
          };  
   
          window.addEventListener('scroll', handleScroll);  
          return () => {  
              window.removeEventListener('scroll', handleScroll);  
          };  
      }, []);  
   
      const fetchKPIData = async (start, end, user = '') => {  
          setIsLoading(true);  
          try {  
              const response = await fetch(`/api/kpidetails`, {  
                  method: 'POST',  
                  headers: {  
                      'Content-Type': 'application/json',  
                  },  
                  body: JSON.stringify({ start, end, user }),  
              });  
              const result = await response.json();  
              setKPIData(result);  
              setUniqueUserNames(result.uniqueUserNames || []);  
          } catch (error) {  
              console.error('Error fetching data:', error);  
          } finally {  
              setIsLoading(false);  
          }  
      };  
   
      const handleSubmitDateRange = () => {  
          if (startDate && endDate) {  
              console.log(`Fetching KPI details from ${startDate} to ${endDate}`);  
              setSubmittedRange(`${startDate} - ${endDate}`);  
              fetchKPIData(startDate, endDate);  
          } else {  
              alert('Please select both start and end dates.');  
          }  
      };  
   
      const handleUserChange = (e) => {  
          const user = e.target.value;  
          setSelectedUser(user);  
          if (startDate && endDate && user) {  
              console.log(`Fetching KPI details for user ${user} from ${startDate} to ${endDate}`);  
              setSubmittedRange(`${startDate} - ${endDate} | User: ${user}`);  
              fetchKPIData(startDate, endDate, user);  
          }  
      };  
   
      return (  
  <>  
    <h1 style={{ textAlign: "center", fontSize: "2rem", color: "#333", marginBottom: "20px", marginTop:"20px" }}>Analytics Dashboard</h1>  
    <div className="container_KPI">  
      <div className="left-container_KPI">  
        {/* Date Picker and User Dropdown */}  
        <div className="datepickercontainer_KPI">  
          <div className="date-picker_KPI">  
            <div className="startdate_KPI">  
              <label htmlFor="start-date-picker">Start date:</label>  
              <input  
                type="date"  
                id="start-date-picker"  
                name="start-date-picker"  
                value={startDate}  
                onChange={(e) => setStartDate(e.target.value)}  
              />  
            </div>  
            <div className="enddate_KPI">  
              <label htmlFor="end-date-picker">End date:</label>  
              <input  
                type="date"  
                id="end-date-picker"  
                name="end-date-picker"  
                value={endDate}  
                onChange={(e) => setEndDate(e.target.value)}  
              />  
            </div>  
          </div>  
          <button onClick={handleSubmitDateRange}>Submit</button>  
        </div>  
        <div className="user-dropdown_KPI">  
          <select  
            id="unique-user-dropdown"  
            name="unique-user-dropdown"  
            value={selectedUser}  
            onChange={handleUserChange}  
          >  
            <option value="">Select a unique user</option>  
            {uniqueUserNames.length > 0 ? (  
              uniqueUserNames.map((name, index) => (  
                <option key={index} value={name}>  
                  {name}  
                </option>  
              ))  
            ) : (  
              <option value="">No unique users available</option>  
            )}  
          </select>  
        </div>  
        {selectedUser && (  
          <div className="table-section">  
            <h2>User Metrics for {selectedUser}</h2>  
            <table className="table_KPI">  
              <thead>  
                <tr>  
                  <th>User Metric</th>  
                  <th>User Value</th>  
                </tr>  
              </thead>  
              <tbody>  
                <tr>  
                  <td>{selectedUser} Accessing Knowledge Articles</td>  
                  <td>  
                    {KPIData.uniqueUserHits !== undefined  
                      ? KPIData.uniqueUserHits  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Tickets Created by {selectedUser}</td>  
                  <td>  
                    {KPIData.userTicketsCreated !== undefined  
                      ? KPIData.userTicketsCreated  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Tickets Updated by {selectedUser}</td>  
                  <td>  
                    {KPIData.userTicketsUpdated !== undefined  
                      ? KPIData.userTicketsUpdated  
                      : "N/A"}  
                  </td>  
                </tr>  
                 <tr>  
                  <td>{selectedUser} accessed the bot</td>  
                  <td>  
                    {KPIData.useraccessingbot !== undefined  
                      ? KPIData.useraccessingbot  
                      : "N/A"}  
                  </td>  
                </tr>  
              </tbody>  
            </table>  
          </div>  
        )}  
      </div>  
 
      <div className="right-container_KPI">  
        <div className="table-row">  
          <div className="table-section">  
            <h2>Bot Adoption</h2>  
            <table className="table_KPI">  
              <tbody>  
                {/* <tr>  
                  {/* <td>Current User Base
                  <InfoTooltip description={METRIC_INFO.CURRENT_USER_BASE} />  
                  </td>   */}
                        {/* <td>
                          {KPIData.totalSessions !== undefined ?
                            16400 : "N/A"}
                        </td>
                      </tr>  */}
                      <tr>
                        <td>Pinned user count
                        <InfoTooltip description={METRIC_INFO.PINNED_USER_COUNT} />
                        </td>
                        <td>
                          {KPIData.pinnedUserCount !== undefined ? KPIData.pinnedUserCount : "N/A"}
                        </td>
                      </tr>
                <tr>  
                  <td>Active Users
                  <InfoTooltip description={METRIC_INFO.UNIQUE_USERS} />
                  </td>  
                  <td>  
                    {KPIData.uniqueUsers !== undefined  
                      ? KPIData.uniqueUsers  
                      : "N/A"}  
                  </td>  
                </tr>  
                 <tr>
                  <td>Returning Users
                  <InfoTooltip description={METRIC_INFO.RETURNING_USERS} />
                  </td>  
                  <td>  
                     {KPIData.usersMoreThanOnce !== undefined  
                      ? KPIData.usersMoreThanOnce  
                      : "N/A"}  
                  </td> 
                </tr>
                <tr>  
                  <td>AskIT Usage Rate
                  <InfoTooltip description={METRIC_INFO.USAGE_RATE} />
                  </td>  
                  <td>  
                    {KPIData.Adoption_Rate !== undefined  
                      ? `${KPIData.Adoption_Rate.toFixed(2)}%`  
                      : "N/A"}  
                  </td>  
                </tr> 
                {/* <tr>  
                  <td>AskIT Accuracy
                  <InfoTooltip description={METRIC_INFO.ASKIT_ACCURACY} />
                  </td>  
                  <td>  
                  {KPIData.askitAccuracy !== undefined ? `${KPIData.askitAccuracy}%` : "N/A"} 
                  </td>  
                </tr> */}
                <tr>
                   <td>AskIT Adoption Rate
                    <InfoTooltip description={METRIC_INFO.Adoption_Rate} />
                    </td>  
                  <td>  
                     {KPIData.Adoption_wrt_returning_unique_users !== undefined  
                      ? `${KPIData.Adoption_wrt_returning_unique_users}%`  
                      : "N/A"}  
                  </td> 
                </tr>
                {/* <tr>
                   <td>Returning Users</td>  
                  <td>  
                     {KPIData.usersMoreThanOnce !== undefined  
                      ? KPIData.usersMoreThanOnce  
                      : "N/A"}  
                  </td> 
                </tr> */}
              </tbody>  
            </table>  
          </div>  

          
          {/* <div className="table-section">  
            <h2>Evaluation metric</h2>  
            <table className="table_KPI">  
              <tbody>  
                <tr>  
                  <td>Bounce Rate</td>  
                  <td>  
                    {KPIData.Bounce_rate !== undefined  
                      ? KPIData.Bounce_rate  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Self Service</td>  
                  <td>  
                    {KPIData.SelfService !== undefined  
                      ? KPIData.SelfService  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Evaluation Rate</td>  
                  <td>  
                    {KPIData.Evaluation_Rate !== undefined  
                      ? KPIData.Evaluation_Rate  
                      : "N/A"}  
                  </td>  
                </tr>
                <tr>  
                  <td>User Resolved Incidents</td>  
                  <td>  
                    {KPIData.ticketsResolved !== undefined  
                      ? KPIData.ticketsResolved  
                      : "N/A"}  
                  </td>  
                </tr> 
                <tr>  
                  <td>Reopened Incidents</td>  
                  <td>  
                    {KPIData.ticketsReopened !== undefined  
                      ? KPIData.ticketsReopened  
                      : "N/A"}  
                  </td>  
                </tr> 
                <tr>  
                  <td>Incident Status Check</td>  
                  <td>  
                    {KPIData.TicketStatus !== undefined  
                      ? KPIData.Ticketstatuscount  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Service Request Status Check</td>  
                  <td>  
                    {KPIData.RequestStatus !== undefined  
                      ? KPIData.RequestStatuscount 
                      : "N/A"}  
                  </td>  
                </tr>  
              </tbody>  
            </table>  
          </div>   */}

             {/* <div className="table-section">  
            <h2>Bot Effectiveness</h2>  
            <table className="table_KPI">  
              <tbody>  
                <tr>  
                  <td>Total Interactions</td>  
                  <td>  
                    {KPIData.Total_interactions !== undefined  
                      ? KPIData.Total_interactions  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Interactions Resolved</td>  
                  <td>  
                    {KPIData.Interactions_Resolved !== undefined  
                      ? KPIData.Interactions_Resolved  
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Accuracy</td>  
                  <td>  
                    {KPIData.Accuracy_Interactions !== undefined  
                      ? `${KPIData.Accuracy_Interactions}%`   
                      : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Self Service</td>  
                  <td>  
                    {KPIData.SelfService !== undefined  
                      ? KPIData.SelfService  
                      : "N/A"}    
                  </td>  
                </tr>  
                <tr>  
                  <td>Evaluation Rate</td>  
                  <td>  
                      {KPIData.Evaluation_Rate !== undefined  
                      ? KPIData.Evaluation_Rate  
                      : "N/A"}
                  </td>  
                </tr>  
              </tbody>  
            </table>  
          </div>   */}

           <div className="table-section">  
            <h2>Bot Sessions</h2>  
            <table className="table_KPI">  
              <tbody>  
                <tr>  
                  <td>Total Sessions
                  <InfoTooltip description={METRIC_INFO.NUMBER_OF_SESSIONS} last={true} />
                  </td>  
                  <td>  
                    {KPIData.totalSessions !== undefined  
                    ? KPIData.totalSessions  
                    : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Agent Transfers
                  <InfoTooltip description={METRIC_INFO.AGENT_TRANSFERS} last={true} />
                  </td>  
                  <td>  
                    {KPIData.agentTransfers !== undefined  
                    ? KPIData.agentTransfers  
                    : "N/A"}    
                  </td>  
                </tr>  
                <tr>  
                  <td>Chats Handled Rate
                  <InfoTooltip description={METRIC_INFO.CHATS_HANDLED} last={true}/>
                  </td>  
                  <td>  
                    {KPIData.chatsHandled !== undefined  
                    ? `${KPIData.chatsHandled}%`  
                    : "N/A"}   
                  </td>  
                </tr>  
                <tr>  
                  <td>Void Sessions
                  <InfoTooltip description={METRIC_INFO.VOID_SESSIONS} last={true}/>
                  </td>  
                  <td>  
                    {KPIData.Void !== undefined ? KPIData.Void : "N/A"}  
                  </td>  
                </tr>  
                <tr>  
                  <td>Bounce Rate
                  <InfoTooltip description={METRIC_INFO.BOUNCE_RATE} last={true}/>
                  </td>  
                  <td>  
                      {KPIData.Bounce_rate !== undefined  
                      ? `${KPIData.Bounce_rate}%`  
                      : "N/A"}    
                  </td>  
                </tr>  
              </tbody>  
            </table>  
          </div>  
        </div>  
 
      


         <div className="table-section">  
          <h2>Bot Effectiveness</h2>  
          <div className="bot-effectiveness-section">  
            <div className="effectiveness-metrics">  
              {/* Group 1 */}  
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Total Interactions
                <InfoTooltip description={METRIC_INFO.TOTAL_INTERACTIONS} isbutton={false}/>  
                </div>  
                <div className="metric-value">  
                  {KPIData.actual_tot_interactions !== undefined  
                      ? KPIData.actual_tot_interactions  
                      : "N/A"}  
                </div>  
              </div>  
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Interactions Responded
                <InfoTooltip description={`Number of conversations successfully completed.`} isbutton={false} />
                </div>  
                <div className="metric-value">  
                  {KPIData.Interactions_Resolved !== undefined  
                      ? KPIData.Interactions_Resolved  
                      : "N/A"}  
                </div>  
              </div>  
              <div className="metric metric-with-tooltip">
                      <div className="metric-title">Abandoned Interactions
                      <InfoTooltip description={METRIC_INFO.ABANDONED_INTERACTIONS} isbutton={false} /> 
                      </div>
                      <div className="metric-value">
                        {KPIData.Abandoned !== undefined
                          ? KPIData.Abandoned
                          : "N/A"}
                      </div>
                    </div>
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">AskIT Accuracy
                <InfoTooltip description={METRIC_INFO.ASKIT_ACCURACY} isbutton={false} last={true} />  
                </div>  
                <div className="metric-value">  
                  {KPIData.askitAccuracy !== undefined  
                      ? `${KPIData.askitAccuracy}%`   
                      : "N/A"} 
                </div>  
              </div>  
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Self Service Rate
                <InfoTooltip description={METRIC_INFO.SELF_SERVICE_RATE} isbutton={false} last={true}/>
                </div>  
                <div className="metric-value">  
                  {KPIData.SelfService !== undefined  
                      ? `${KPIData.SelfService}%`  
                      : "N/A"}    
                </div>  
              </div>  
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Evaluation Rate
                <InfoTooltip description={METRIC_INFO.EVALUATION_RATE} isbutton={false}/>
                </div>  
                <div className="metric-value">  
                   {KPIData.Evaluation_Rate !== undefined  
                      ? `${KPIData.Evaluation_Rate}%`  
                      : "N/A"}
                </div>  
                
              </div>
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Positive Feedback 👍
                <InfoTooltip description={METRIC_INFO.POSITIVE_FEEDBACK} isbutton={false}/>
                </div>  
                <div className="metric-value">  
                   {KPIData.positiveFeedbacks !== undefined  
                      ? `${KPIData.positiveFeedbacks}`  
                      : "N/A"}
                </div>  
              </div>
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Negative Feedback 👎
                <InfoTooltip description={METRIC_INFO.NEGATIVE_FEEDBACK} isbutton={false} last={true}/>
                </div>  
                <div className="metric-value">  
                   {KPIData.negativeFeedbacks!== undefined  
                      ? `${KPIData.negativeFeedbacks}`  
                      : "N/A"}
                </div>  
              </div> 
                    
                  </div> 
            
            <div className="effectiveness-metrics">  
              {/* Group 2 */}  
              {/* <div className="metric">  
                <div className="metric-title">Status Check Incident</div>  
                <div className="metric-value">  
                   {KPIData.TicketStatus !== undefined  
                      ? KPIData.TicketStatus  
                      : "N/A"}
                </div>  
              </div>  
              <div className="metric">  
                <div className="metric-title">Status Check Service Request</div>  
                <div className="metric-value">  
                  {KPIData.RequestStatus !== undefined? KPIData.RequestStatus : "NA"}
                </div>  
              </div>   */}


              {/* <div className="metric">  
                <div className="metric-title">Accuracy</div>  
                <div className="metric-value">  
                  {KPIData.accuracy !== undefined  
                    ? `${KPIData.accuracy}%`  
                    : "N/A"}  
                </div>  
              </div>   */}
            </div>  
 
            <div className="effectiveness-metrics">  
              {/* Group 3 */}  
              {/* <div className="metric">  
                <div className="metric-title">Positive Feedback</div>  
                <div className="metric-value">  
                  {KPIData.positiveFeedbacks !== undefined  
                    ? KPIData.positiveFeedbacks  
                    : "N/A"}  
                </div>  
              </div>   */}
              {/* <div className="metric">  
                <div className="metric-title">Negative Feedback</div>  
                <div className="metric-value">  
                  {KPIData.negativeFeedbacks !== undefined  
                    ? KPIData.negativeFeedbacks  
                    : "N/A"}  
                </div>  
              </div>   */}
              {/* <div className="metric">  
                <div className="metric-title">CSAT</div>  
                <div className="metric-value">  
                  {KPIData.csat !== undefined ? `${KPIData.csat}%` : "N/A"}  
                </div>  
              </div>   */}
            </div>  
          </div>    
        </div>  



         <div className="table-section">  
          <h2>Bot ITSM Ticket Handling</h2>  
          <div className="bot-effectiveness-section">  
            <div className="effectiveness-metrics">  
              {/* Group 1 */}  
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Incidents Created
                <InfoTooltip description={METRIC_INFO.INCIDENTS_CREATED} isbutton={false} />
                </div>  
                <div className="metric-value">  
                  {KPIData.ticketsCreated !== undefined  
                      ? KPIData.ticketsCreated  
                      : "N/A"}    
                </div>  
              </div>  

                  <div className="metric metric-with-tooltip">  
                <div className="metric-title">Incident Status Check
                <InfoTooltip description={METRIC_INFO.INCIDENT_STATUS_CHECK} isbutton={false}/>
                </div>  
                <div className="metric-value">  
                 {KPIData.TicketStatus !== undefined  
                      ? KPIData.Ticketstatuscount  
                      : "N/A"} 
                </div>  
              </div>  
              
              <div className="metric metric-with-tooltip ">  
                <div className="metric-title">Service Request Status Check
                <InfoTooltip description={METRIC_INFO.REQUEST_STATUS_CHECK} isbutton={false} />
                </div>  
                <div className="metric-value">  
                  {KPIData.RequestStatus !== undefined  
                      ? KPIData.RequestStatuscount 
                      : "N/A"}   
                </div>  
              </div> 

              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Incidents Updated
                <InfoTooltip description={METRIC_INFO.INCIDENT_UPDATE} isbutton={false} last={true}/>
                </div>  
                <div className="metric-value">  
                  {KPIData.ticketsUpdated !== undefined  
                      ? KPIData.ticketsUpdated  
                      : "N/A"}  
                </div>  
              </div>  

              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Service Request Updated
                <InfoTooltip description={METRIC_INFO.SERVICE_REQUEST_UPDATE} isbutton={false} last={true}/>
                </div>  
                <div className="metric-value">  
                  {KPIData.ServiceRequestUpdated !== undefined  
                      ? KPIData.ServiceRequestUpdated  
                      : "N/A"}  
                </div>  
              </div>  
                <div className="metric metric-with-tooltip">  
                <div className="metric-title">User Resolved Incident
                <InfoTooltip description={METRIC_INFO.USER_RESOLVED_INCIDENTS} isbutton={false} />
                </div>  
                <div className="metric-value">  
                 {KPIData.ticketsResolved !== undefined  
                      ? KPIData.ticketsResolved  
                      : "N/A"}  
                </div>  
              </div>
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">Reopened Tickets
                <InfoTooltip description={METRIC_INFO.REOPENED_INCIDENTS} isbutton={false} last={true} />
                </div>  
                <div className="metric-value">  
                 {KPIData.ticketsReopened !== undefined  
                      ? KPIData.ticketsReopened  
                      : "N/A"} 
                </div>  
              </div> 
            </div>  

            <div className="effectiveness-metrics">  
              {/* Group 2 */}  
              {/* <div className="metric">  
                <div className="metric-title">Status Check Incident</div>  
                <div className="metric-value">  
                   {KPIData.TicketStatus !== undefined  
                      ? KPIData.TicketStatus  
                      : "N/A"}
                </div>  
              </div>  
              <div className="metric">  
                <div className="metric-title">Status Check Service Request</div>  
                <div className="metric-value">  
                  {KPIData.RequestStatus !== undefined? KPIData.RequestStatus : "NA"}
                </div>  
              </div>   */}


              {/* <div className="metric">  
                <div className="metric-title">Accuracy</div>  
                <div className="metric-value">  
                  {KPIData.accuracy !== undefined  
                    ? `${KPIData.accuracy}%`  
                    : "N/A"}  
                </div>  
              </div>   */}
            </div>  
 
            <div className="effectiveness-metrics">  
              {/* Group 3 */}  
              {/* <div className="metric">  
                <div className="metric-title">Positive Feedback</div>  
                <div className="metric-value">  
                  {KPIData.positiveFeedbacks !== undefined  
                    ? KPIData.positiveFeedbacks  
                    : "N/A"}  
                </div>  
              </div>   */}
              {/* <div className="metric">  
                <div className="metric-title">Negative Feedback</div>  
                <div className="metric-value">  
                  {KPIData.negativeFeedbacks !== undefined  
                    ? KPIData.negativeFeedbacks  
                    : "N/A"}  
                </div>  
              </div>   */}
              {/* <div className="metric">  
                <div className="metric-title">CSAT</div>  
                <div className="metric-value">  
                  {KPIData.csat !== undefined ? `${KPIData.csat}%` : "N/A"}  
                </div>  
              </div>   */}
            </div>  
          </div>  
        </div>  

        <div className="table-section">  
          <h2>Knowledge Management Effectiveness</h2>  
          <div className="effectiveness-metrics">  
              {/* Group 2 */}  
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">KM Queries Answered
                <InfoTooltip description={METRIC_INFO.KB_QUERIES_ANSWERED} isbutton={false} />
                </div>  
                <div className="metric-value">  
                  {KPIData.KMBotInfoAnswred !== undefined  
                    ? KPIData.KMBotInfoAnswred  
                    : "N/A"}  
                </div>  
              </div>  
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">KM Queries UnAnswered
                <InfoTooltip description={METRIC_INFO.KB_QUERIES_UNANSWERED} isbutton={false} />
                </div>  
                <div className="metric-value">  
                  {KPIData.KMBotInfoUnAnswred !== undefined  
                    ? KPIData.KMBotInfoUnAnswred  
                    : "N/A"}  
                </div>  
              </div>  
              <div className="metric metric-with-tooltip">  
                <div className="metric-title">KM Efficiency
                <InfoTooltip description={METRIC_INFO.KB_EFFICIENCY} isbutton={false} last={true} />
                </div>  
                <div className="metric-value">  
                  {KPIData.accuracy !== undefined  
                    ? `${KPIData.accuracy}%`  
                    : "N/A"}  
                </div>  
              </div>  
            </div>  
        </div>  

      </div>  
    </div>  
    <footer style={{backgroundColor:"#f0f2f5"}}></footer>  
  </>  
);  
  }